import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNextStep, getPrevStep } from '../../../utils/steps';
import { ELandingType } from '../../../types/landingType';
import { ILogger, TError } from '@cian/logger/shared';
import { TMeta } from '@cian/logger/shared/types';
import { acceptPublicOffer } from '../../../thunks/joinOtaIndividual/acceptPublicOffer';
import { saveFormAndAcceptOffer } from '../../../thunks/joinOtaIndividual/saveFormAndAcceptOffer';
import { EJoinOtaLegalShortStep } from '../../../types/joinOtaLegalShort/step';

interface IErrorPayload {
  logger: ILogger;
  error: TError;
  extra?: TMeta;
}

export interface IStepsSlice {
  activeStep: EJoinOtaLegalShortStep;
  steps: EJoinOtaLegalShortStep[];
}

const initialState: IStepsSlice = {
  activeStep: EJoinOtaLegalShortStep.Unexpected,
  steps: [EJoinOtaLegalShortStep.Unexpected],
};

const stepsConfigurationSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    setStepsConfiguration(state, action: PayloadAction<IStepsSlice>) {
      state.steps = action.payload.steps;
      state.activeStep = action.payload.activeStep;
    },
    goToNextStep(state) {
      state.activeStep = getNextStep(
        state.steps,
        EJoinOtaLegalShortStep.Unexpected,
        ELandingType.JoinOtaLegalShort,
        state.activeStep,
      ) as EJoinOtaLegalShortStep;
    },
    goToPrevStep(state) {
      state.activeStep = getPrevStep(
        state.steps,
        EJoinOtaLegalShortStep.Unexpected,
        ELandingType.JoinOtaLegalShort,
        state.activeStep,
      ) as EJoinOtaLegalShortStep;
    },
    goToErrorStep: (state, action: PayloadAction<IErrorPayload>) => {
      const { logger, error, extra } = action.payload;
      logger.error(error, extra);

      state.activeStep = EJoinOtaLegalShortStep.Error;
    },
  },
  extraReducers(builder) {
    builder.addCase(acceptPublicOffer.rejected, state => {
      state.activeStep = EJoinOtaLegalShortStep.Error;
    });
    builder.addCase(saveFormAndAcceptOffer.rejected, (state, action) => {
      if (action.payload?.type === 'unknownError') {
        state.activeStep = EJoinOtaLegalShortStep.Error;
      }
    });
  },
});

export const {
  reducer: stepsConfigurationReducer,
  actions: { goToNextStep, goToPrevStep, goToErrorStep, setStepsConfiguration },
} = stepsConfigurationSlice;
